import Immutable from 'immutable';
import { degreeList } from '../../data/degrees';

const degreeListItems = (state = new Immutable.Map(), action) => {
  return state.merge(
    Immutable.fromJS(
      degreeList.reduce((map, property) => {
        map[property.id] = property;
        return map;
      }, {})
    )
  );
};

export default degreeListItems;
